import React, { Component, createRef } from "react";
import { useAuth, useTenantsState } from "../../auth/workosAuth";
import {
  Popover,
  Tab,
  OverlayTrigger,
} from "react-bootstrap";
import { 
  Tooltip, 
  CircularProgress, 
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Box
} from "@mui/material";
import { CSSTransition } from "react-transition-group";
import { config } from "../../constants";
import * as Icon from "react-feather";
import { Helmet } from "react-helmet-async";
import LoadingBar from "react-top-loading-bar";
import WithRouter from "../../HOC/RouterWrapper";
import HorizontalDropdownMenu from "../../components/global/HorizontalDropdown";

import { ReactComponent as RefreshIcon } from "../../assets/img/icons/refresh.svg";
import { ReactComponent as DetailsIcon } from "../../assets/img/icons/details.svg";
import { ReactComponent as StopIcon } from "../../assets/img/icons/StopIcon.svg";
import { ReactComponent as CancelIcon } from "../../assets/img/icons/CancelIcon.svg";
import { ReactComponent as SettingsIcon } from "../../assets/img/icons/SettingsIcon.svg";
import { ReactComponent as PlayIcon } from "../../assets/img/icons/PlayIcon.svg";
import { ReactComponent as FailedIcon } from "../../assets/img/icons/failed.svg";
import { ReactComponent as SuccessIcon } from "../../assets/img/icons/success.svg";
import { ReactComponent as QueuedIcon } from "../../assets/img/icons/queed.svg";
import { ReactComponent as OptionsIcon } from "../../assets/img/icons/OptionsIcon.svg";
import runningIcon from "../../assets/img/icons/running.json";
import Lottie from "lottie-react";

import SearchJobs from "./SearchJobs";
import PushCreatorForm from "../../components/DagCreators/PushCreatorForm";
import DagHistory from "./DagHistory";
import Table from "../../components/global/Table";
import TablePagination from "../../components/global/Table/Pagination";
import { fetchLastRuns } from "../functions.js";
import {
  deletePushService,
  fetchAirflowDagsService,
  stopDagService,
  triggerDagService,
} from "../../services/push";
import DeleteConnectorModal from "../../components/Modals/DeleteConnector";

const TenantContextComponent = (props) => {
  const { user } = useAuth();
  const { tenants } = useTenantsState();
  if (!user) return null;
  const activeTenant = tenants.find((t) => t.tenantId === user.tenantId);

  return <Push {...props} activeTenant={activeTenant} />;
};

class Push extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fields_mapping: [{ source: "", target: "" }],
      loading: false,
      loading_destination_objects: false,
      EditOpen: false,
      datasources: [],
      progress: 40,
      spec_details: [],
      running_dags: [],
      DAGs: [],
      mytasks: [],  // Add mytasks array for fetchLastRuns compatibility
      loading_my_destinations: false,
      loading_connectors: false,
      dag_runs: [],
      destination_id: "",
      historical_dag_runs: [],
      subelements: false,
      selected_datapoint_source: false,
      json_update_endpoint: false,
      source_link: false,
      destination_link: false,
      logs_schedule: false,
      get_dags_status: true,
      push_type: false,
      selected_destination_object: false,
      selected_datapoint_destination: false,
      destination_fields: [],
      modal_history: false,
      activeTab: "all",
      deleting_push_alias: "",
      push_alias: "",
      destination_alias: "",
      mytaps: [],
      modal_edit: false,
      modal_flow: false,
      selected_job: "",
      scheduling: false,
      schedule_day: false,
      jobNameFilters: "",
      jobDestinationFilters: "",
      currentPage: 1,
      perPage: 10,
      isShowingCreatePushForm: false,
      columnsWidth: [0, 0, 0, 0, 0, 0],
      sortedColumn: {
        column: "",
        isAsc: true,
      },
      isAliasSearchOpen: false,
      isDestinationSearchOpen: false,
      filters: {
        status: [],
        subtype: []
      }
    };

    this.tableRef = createRef(null);
    this.isComponentMounted = false; // Flag to track if the component is mounted
  }


  setSelectedPushData = (data) => this.setState(data);

  toggleCreatePushForm = () => {
    this.setState(
      {
        isShowingCreatePushForm: !this.state.isShowingCreatePushForm,
      },
      () => {
        if (!this.state.isShowingCreatePushForm) {
          this.props?.router.navigate("/jobs/push");
        }
      }
    );
  };

  setdbturl = () => {
    const localUrl = "http://127.0.0.1:5000";
    const dbtUrl = config.url.DBT_URL;
    const sqlEditorUrl = config.url.SQL_EDITOR_URL;

    const waitForTenant = setInterval(() => {
      if (this.props.activeTenant?.name) {
        clearInterval(waitForTenant);
        const finalDbtUrl =
          dbtUrl === localUrl
            ? localUrl
            : `${dbtUrl}/${this.props.activeTenant.name}`;
        const finalSqlEditorUrl =
          sqlEditorUrl === localUrl
            ? localUrl
            : `${sqlEditorUrl}/${this.props.activeTenant.name}`;
        this.setState({
          dbt_url: finalDbtUrl,
          sql_editor_url: finalSqlEditorUrl
        });
      }
    }, 500); // Check every 500ms
  };

  getTargetEditedDAGData = () => {
    const edit_push_id = new URLSearchParams(window.location.search).get(
      "edit_push"
    );
    const targetDAG = this.state.DAGs.find((DAG) => DAG.id === edit_push_id);
    return targetDAG;
  };

  getTargetDAGData = () => {
    const history_modal = new URLSearchParams(window.location.search).get(
      "history_modal"
    );
    const targetDAG = this.state.DAGs.find((DAG) => DAG.id === history_modal);
    return targetDAG;
  };

  toggleHistoryDagTable = () => {
    this.setState({
      isShowingDagHistoryTable: !this.state.isShowingDagHistoryTable,
    });
  };

  showInitialHistoryModal = (prevProps) => {
    //prevProps to extract queryParams from pervious render
    if (
      prevProps?.router.location.search.includes("history_modal") &&
      !this.props?.router.location.search.includes("history_modal")
    ) {
      this.setState({
        historical_runs_available: false,
        modal_history: false,
        isShowingDagHistoryTable: false,
      });
    }

    if (
      !prevProps?.router.location.search.includes("history_modal") &&
      this.props?.router.location.search.includes("history_modal")
    ) {
      if (this.getTargetDAGData()) {
        this.toggleHistoryDagTable();
      }
    }
  };

  showInitialEditView = (prevProps) => {
    //prevProps to extract queryParams from pervious render
    if (
      prevProps?.router.location.search.includes("edit_push") &&
      !this.props?.router.location.search.includes("edit_push")
    ) {
      this.setState({
        activeTab: "all",
        isShowingCreatePushForm: false,
      });
    }

    if (
      !prevProps?.router.location.search.includes("edit_push") &&
      this.props?.router.location.search.includes("edit_push")
    ) {
      if (!this.state.isShowingCreatePushForm) {
        this.toggleCreatePushForm();
      }
    }
  };

  redirectToHistoryModalView = (DAG) => {
    // Use dag_id if available (for proper DAG identification), otherwise fall back to id
    const dagIdentifier = DAG.dag_id || DAG.id;
    this.props?.router.navigate(`/jobs/push?history_modal=${dagIdentifier}`);
  };

  handleToggle = (name) => {
    this.setState({ [name]: !this.state[name] });
  };

  calculateTotalPages = () => {
    const filteredLength = this.state.DAGs.filter((DAG) =>
      this.filterJobNames(DAG) && 
      this.filterJobDestination(DAG) &&
      this.filterByColumn(DAG, "status", this.state.filters.status) &&
      this.filterByColumn(DAG, "subtype", this.state.filters.subtype)
    ).length;
    return filteredLength ? Math.ceil(filteredLength / this.state.perPage) : 1;
  };

  paginateArray = (
    array,
    activePage = this.state.currentPage,
    perPageCount = this.state.perPage
  ) => {
    const startIndex = (activePage - 1) * perPageCount;
    const endIndex = startIndex + perPageCount;

    return array.slice(startIndex, endIndex);
  };

  async componentDidMount() {
    this.isComponentMounted = true;
    this.setState({ progress: 70 });
    await this.fetchAirflowDags();
    this.setState({ progress: 100 }, () => {});
    this.setdbturl();

    // const resizableColumnsWidth = this.tableRef.current.clientWidth * 0.83;
    // const lastColumnWidth = this.tableRef.current.clientWidth * 0.05;
    // const eachColumnWidth = resizableColumnsWidth / 5.4;
    // this.setState({
    //   columnsWidth: [...new Array(5).fill(eachColumnWidth), lastColumnWidth],
    // });
  }

  componentWillUnmount = () => {
    this.isComponentMounted = false;
  };

  componentDidUpdate(prevProps, prevState) {
    // Handle query parameter changes
    const hasQueryParamsChanged =
      this?.props?.router?.location &&
      prevProps?.router?.location &&
      this.props?.router.location.search !== prevProps?.router.location.search;

    const hasInitialHistoryModalView =
      prevProps?.router.location.search.includes("history_modal") ||
      this.props?.router.location.search.includes("history_modal");

    const hasInitialEditView =
      prevProps?.router.location.search.includes("edit_push") ||
      this.props?.router.location.search.includes("edit_push");

    if (hasQueryParamsChanged) {
      if (hasInitialHistoryModalView) {
        this.showInitialHistoryModal(prevProps);
      }

      if (hasInitialEditView) {
        this.showInitialEditView(prevProps);
      }
    }

    if (!prevState.DAGs.length && this.state.DAGs.length) {
      if (this.getTargetDAGData()) {
        this.toggleHistoryDagTable();
      }

      if (this.getTargetEditedDAGData()) {
        if (!this.state.isShowingCreatePushForm) {
          this.toggleCreatePushForm();
        }
      }
    }

    // Sync DAGs with mytasks whenever mytasks changes
    if (prevState.mytasks !== this.state.mytasks && this.state.mytasks.length > 0) {
      const updatedDAGs = this.state.DAGs.map(dag => {
        const matchingTask = this.state.mytasks.find(task => 
          task.datajolt_task_id === dag.id
        );
        if (matchingTask) {
          // Only update timestamps if they exist in the matching task
          // This prevents overwriting existing formatted timestamps with undefined
          return {
            ...dag,
            status: matchingTask.status,
            last_started: matchingTask.last_started !== undefined ? matchingTask.last_started : dag.last_started,
            last_ended: matchingTask.last_ended !== undefined ? matchingTask.last_ended : dag.last_ended,
            rows: matchingTask.rows
          };
        }
        return dag;
      });
      
      // Only update if there are actual changes
      const hasChanges = updatedDAGs.some((dag, index) => 
        dag.status !== this.state.DAGs[index].status ||
        dag.last_started !== this.state.DAGs[index].last_started ||
        dag.last_ended !== this.state.DAGs[index].last_ended ||
        dag.rows !== this.state.DAGs[index].rows
      );
      
      if (hasChanges) {
        this.setState({ DAGs: updatedDAGs });
      }
    }
  }


  toggleEditModal = (DAG) => {
    this.setState({ selected_job: DAG, modal_edit: !this.state.modal_edit });
  };

  fetchAirflowDags = async () => {
    this.setState({
      editing: false,
      get_dags_status: true,
      DAGs: [],
      loading: true,
      loading_spinner_pushes: true,
      progress: 60,
    });

    const response = await fetchAirflowDagsService();

    if (response) {
      const dags = response.data["dags_list"];
      
      // Extract proper DAG ID for pushes
      const processedDags = dags.map(dag => {
        // For push DAGs, extract the actual DAG ID from datajolt_task_id
        // datajolt_task_id format: dbt_task_group.exposure.dbt_models.daily_center_extract_dave
        // Actual DAG ID should be: push_daily_center_extract_dave
        if (dag.id && dag.id.includes('exposure.dbt_models.')) {
          const alias = dag.id.split('.').pop(); // Get the last part (e.g., daily_center_extract_dave)
          return {
            ...dag,
            dag_id: `push_${alias}`, // Add the proper dag_id field
            datajolt_task_id: dag.id  // Keep the original datajolt_task_id
          };
        }
        return dag;
      });
      
      // Create mytasks array with datajolt_task_id field for fetchLastRuns
      const mytasks = processedDags.map(dag => ({
        ...dag,
        datajolt_task_id: dag.datajolt_task_id || dag.id
      }));
      
      this.setState({
        loading: false,
        DAGs: processedDags,
        mytasks: mytasks,
        options: [],
      });
      
      // Check for running or queued pushes and start polling
      for (var dag of processedDags) {
        if (dag["status"] === "running" || dag["status"] === "queued") {
          if (dag.id) {
            fetchLastRuns(
              dag.id,
              1,
              this.setState.bind(this),
              () => this.isComponentMounted
            );
          }
        }
      }
    }

    this.setState({
      progress: 100,
      loading: false,
      loading_spinner_pushes: false,
    });
  };

  stopDAG = async (DAG_id, dag_run_id) => {
    this.setState({ stopping: true });
    this.setState({ progress: 80 });

    await stopDagService(DAG_id, dag_run_id);

    this.setState({ progress: 100, stopping: false });
  };

  toggleDeletepushmodal = (alias, push_id) => {
    this.setState({
      delete_push_id: push_id,
      deleting_push_alias: alias,
      modal_delete_push: !this.state.modal_delete_push,
    });
  };

  toggleDeletedestinationmodal = (destination_name, alias, destination_id) => {
    this.setState({
      delete_destination_id: destination_id,
      deleting_destination_alias: alias,
      destinaton_to_delete: destination_name,
      modal_delete_destination: !this.state.modal_delete_destination,
    });
  };

  triggerDAG = async (dag_id) => {
    console.log("[Push] Triggering DAG:", dag_id);
    this.setState({ running_dags: [...this.state.running_dags, dag_id] });
    
    // Find the DAG and update its status to running IMMEDIATELY
    const dag = this.state.DAGs.find(d => d.id === dag_id);
    if (dag && dag.id) {
      console.log("[Push] Found DAG, updating status to running");
      // Update status immediately in both DAGs and mytasks
      // Clear last_ended when starting a new run
      this.setState(prevState => ({
        DAGs: prevState.DAGs.map(d => 
          d.id === dag_id 
            ? { ...d, status: "running", last_started: new Date().toISOString(), last_ended: null }
            : d
        ),
        mytasks: prevState.mytasks.map(task => 
          task.datajolt_task_id === dag_id 
            ? { ...task, status: "running", last_started: new Date().toISOString(), last_ended: null }
            : task
        )
      }));
      
      // Start polling for status updates
      fetchLastRuns(
        dag.id,
        1,
        this.setState.bind(this),
        () => this.isComponentMounted
      );
    }
    
    // Trigger the DAG asynchronously (don't wait for it)
    triggerDagService(dag_id).then(() => {
      console.log("[Push] DAG triggered successfully");
    }).catch((error) => {
      console.error("[Push] Error triggering DAG:", error);
      // Reset status on error
      this.setState(prevState => ({
        DAGs: prevState.DAGs.map(d => 
          d.id === dag_id 
            ? { ...d, status: "failed" }
            : d
        ),
        mytasks: prevState.mytasks.map(task => 
          task.datajolt_task_id === dag_id 
            ? { ...task, status: "failed" }
            : task
        ),
        running_dags: prevState.running_dags.filter(id => id !== dag_id)
      }));
    });
  };

  deletePush = async (push_alias, push_id) => {
    this.setState({ deleting_push: true });

    const isSuccess = await deletePushService(
      this.state.deleting_push_alias,
      push_id,
      push_alias
    );

    if (isSuccess) {
      this.fetchAirflowDags();
      this.toggleDeletepushmodal("");
    }

    this.setState({ deleting_push: false });
  };

  filterJobNames = (DAG) => {
    const target = DAG.alias;
    if (this.state.jobNameFilters) {
      if (target.toLowerCase().includes(this.state.jobNameFilters.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  
  filterJobDestination = (DAG) => {
    const target = DAG.push_to;
    if (this.state.jobDestinationFilters) {
      if (target.toLowerCase().includes(this.state.jobDestinationFilters.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  filterByColumn = (DAG, column, values) => {
    return !values.length || values.includes(DAG[column]);
  };

  toggleFilter = (columnName, values) => {
    this.setState({filters: {...this.state.filters, [columnName]: values}, currentPage: 1});
  }

  fetchDAGLastRuns = async (dag_id, page_limit, toastId) => {
    // For pushes, the dag_id IS the datajolt_task_id
    const dag = this.state.DAGs.find(d => d.id === dag_id);
    if (!dag || !dag.id) {
      console.warn(`No DAG found with id ${dag_id}`);
      return;
    }

    // Ensure mytasks is synced with DAGs
    if (!this.state.mytasks.find(t => t.datajolt_task_id === dag_id)) {
      this.setState(prevState => ({
        mytasks: prevState.DAGs.map(d => ({
          ...d,
          datajolt_task_id: d.id
        }))
      }));
    }

    // Use fetchLastRuns with the dag.id (which is the datajolt_task_id)
    fetchLastRuns(
      dag.id,
      page_limit,
      this.setState.bind(this),
      () => this.isComponentMounted
    );
  };

  onSortColumn = (column) => {
    const dags = this.state.DAGs.map((dag) => ({ ...dag }));
    let isAsc = true;

    if (this.state.sortedColumn.column === column) {
      isAsc = !this.state.sortedColumn.isAsc;
    }

    this.setState({
      DAGs: dags.sort((a, b) => {
        if (isAsc) {
          return a[column]?.toLowerCase() < b[column]?.toLowerCase() ? 1 : -1;
        } else {
          return b[column]?.toLowerCase() < a[column]?.toLowerCase() ? 1 : -1;
        }
      }),
    });
    this.setState({ sortedColumn: { column, isAsc } });
  };

  renderStatusIcon = (status) => {
    if (status === "failed" || status === "cancelled") {
      return <FailedIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "success") {
      return <SuccessIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "queued") {
      return <QueuedIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "running" || status === "waiting") {
      return (
        <Lottie
          animationData={runningIcon}
          loop
          style={{ width: "16px", height: "16px" }}
        />
      );
    } else {
      return null;
    }
  }

  renderDestinationTypeLogo = (subtype) => {
    // Find the DAG that matches this subtype to get its logo
    const dag = this.state.DAGs.find(d => d.subtype === subtype);
    if (dag && dag.logo) {
      return (
        <img 
          src={dag.logo} 
          alt={subtype} 
          style={{ 
            width: "20px", 
            height: "20px", 
            borderRadius: "2px",
            objectFit: "contain"
          }}
        />
      );
    }
    return null;
  }

  render() {
    const { navigate } = this.props?.router;

    return (
      <div className="container-fluid py-3">
        <LoadingBar color="#0245a0" progress={this.state.progress} />
        <Helmet title="Datajolt | Data Pushes" />
        <Tab.Container id="taps-tabs" activeKey={this.state.activeTab}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "12px 8px",
              height: "45px",
            }}
          >
            <h4 style={{ margin: 0 }}>
              <b style={{ color: "#090E47", marginRight: "10px" }}>
                My Data Pushes{" "}
                {this.state.loading ? "" : "(" + this.state.DAGs.length + ")"}
              </b>
              <OverlayTrigger
                trigger="click"
                placement="bottom"
                overlay={
                  <Popover id={`popover-positioned-bottom`}>
                    <Popover.Header as="h3">
                      {"What are Pushes?"}
                    </Popover.Header>
                    <Popover.Body>
                      Pushes help you push the data into the destination where
                      it will be consumed.
                      <br />
                      There can be several pushes to the same destination.
                    </Popover.Body>
                  </Popover>
                }
              >
                <DetailsIcon />
              </OverlayTrigger>
            </h4>

            {this.state.activeTab === "all" && (
              <>
                <center style={{ marginLeft: "auto" }}>
                  <Tooltip title="Refresh Pushes" placement="bottom">
                    {this.state.loading_spinner_pushes ? (
                      <CircularProgress size={16} sx={{ color: "#2c49fc" }} />
                    ) : (
                      <RefreshIcon onClick={() => this.componentDidMount()} />
                    )}
                  </Tooltip>

                  <Button
                    variant="contained"
                    sx={{
                      marginLeft: "10px",
                      fontSize: "11px",
                      fontWeight: 500,
                      height: "32px",
                      padding: "0 16px",
                      textTransform: "none",
                      borderRadius: "6px",
                      background: "#2D49FD",
                      border: "1px solid #2D49FD",

                      "&:hover": {
                        opacity: 0.9
                      }
                    }}
                    onClick={this.toggleCreatePushForm}
                  >
                    Create a push{" "}
                    <Icon.UploadCloud
                      style={{ marginLeft: "5px" }}
                      size={14}
                      color="white"
                    />
                  </Button>
                </center>
              </>
            )}
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="all">
              <hr
                style={{
                  margin: "0 8px",
                }}
              />
              {!this.state.loading_spinner_pushes &&
              this.state.DAGs.length === 0 ? (
                <div style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '8px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  padding: '60px 40px',
                  textAlign: 'center',
                  marginLeft: '8px',
                  marginRight: '8px',
                }}>
                  <div style={{
                    marginBottom: '16px',
                  }}>
                    <Icon.UploadCloud size={48} color="#6c757d" />
                  </div>
                  <h3 style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#293042',
                    margin: '0 0 8px 0',
                    fontFamily: "'Poppins', sans-serif",
                  }}>No data push yet</h3>
                  <p style={{
                    fontSize: '14px',
                    color: '#6c757d',
                    margin: '0 0 24px 0',
                    fontFamily: "'Poppins', sans-serif",
                  }}>Set up your first data push to get started</p>
                  <Button
                    variant="outlined"
                    sx={{
                      fontSize: '11px',
                      textTransform: 'none',
                      borderRadius: '6px',
                    }}
                    onClick={() => this.toggleCreatePushForm()}
                  >
                    Create Push
                  </Button>
                </div>
              ) : (
                <>
                  <div style={{ margin: "8px 8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px", flexWrap: "wrap", justifyContent: "space-between" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                        <Box 
                          sx={{ 
                            width: "200px",
                            "& .MuiOutlinedInput-root": {
                              height: "32px",
                              minHeight: "32px"
                            },
                            "& .MuiInputBase-input": {
                              height: "32px",
                              padding: "0 14px",
                              lineHeight: "32px"
                            },
                            "& .MuiFormControl-root": {
                              height: "32px"
                            }
                          }}
                        >
                          <SearchJobs
                            onFilterChange={(filters) => this.setState({ jobNameFilters: filters, currentPage: 1 })}
                            filter={this.state.jobNameFilters}
                            isSearchOpen={true}
                            toggleSearch={() => {}}
                            placeholder="Search Push Alias..."
                            size="small"
                          />
                        </Box>

                        <Box 
                          sx={{ 
                            width: "200px",
                            "& .MuiOutlinedInput-root": {
                              height: "32px",
                              minHeight: "32px"
                            },
                            "& .MuiInputBase-input": {
                              height: "32px",
                              padding: "0 14px",
                              lineHeight: "32px"
                            },
                            "& .MuiFormControl-root": {
                              height: "32px"
                            }
                          }}
                        >
                          <SearchJobs
                            onFilterChange={(filters) => this.setState({ jobDestinationFilters: filters, currentPage: 1 })}
                            filter={this.state.jobDestinationFilters}
                            isSearchOpen={true}
                            toggleSearch={() => {}}
                            placeholder="Search Destination..."
                            size="small"
                          />
                        </Box>

                        <FormControl size="small" sx={{ minWidth: 120 }}>
                          <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Status</InputLabel>
                          <Select
                            multiple
                            value={this.state.filters.status}
                            onChange={(e) => this.toggleFilter("status", e.target.value)}
                            input={<OutlinedInput label="Status" />}
                            renderValue={() => this.state.filters.status.length > 0 ? `Status (${this.state.filters.status.length})` : "Status"}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 400,
                                  marginTop: 4,
                                  padding: 0,
                                  overflow: 'hidden',
                                },
                                sx: {
                                  '& .MuiList-root': {
                                    padding: 0,
                                    overflow: 'auto',
                                    maxHeight: 400,
                                  }
                                }
                              },
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                              transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                              },
                            }}
                            sx={{ 
                              maxWidth: 140,
                              fontSize: "10px",
                              fontWeight: 400,
                              "& .MuiSelect-select": {
                                fontSize: "10px",
                                fontWeight: 400
                              }
                            }}
                          >
                            {this.state.loading && (
                              <MenuItem disabled sx={{ 
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "40px 16px",
                                fontSize: "10px",
                                fontWeight: 400,
                                color: "#6b7280"
                              }}>
                                <div style={{ 
                                  display: "flex", 
                                  flexDirection: "column", 
                                  alignItems: "center", 
                                  gap: "12px" 
                                }}>
                                  <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                  <span>Loading statuses...</span>
                                </div>
                              </MenuItem>
                            )}
                            
                            {!this.state.loading && Array.from(new Set(this.state.DAGs.map(d => d.status))).map(status => (
                              <MenuItem key={status} value={status} sx={{ 
                                fontSize: "10px", 
                                fontWeight: 400, 
                                wordBreak: "break-all",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <span>{status}</span>
                                {this.renderStatusIcon(status)}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        <FormControl size="small" sx={{ minWidth: 140 }}>
                          <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Destination Type</InputLabel>
                          <Select
                            multiple
                            value={this.state.filters.subtype}
                            onChange={(e) => this.toggleFilter("subtype", e.target.value)}
                            input={<OutlinedInput label="Destination Type" />}
                            renderValue={() => this.state.filters.subtype.length > 0 ? `Type (${this.state.filters.subtype.length})` : "Destination Type"}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 400,
                                  marginTop: 4,
                                  padding: 0,
                                  overflow: 'hidden',
                                },
                                sx: {
                                  '& .MuiList-root': {
                                    padding: 0,
                                    overflow: 'auto',
                                    maxHeight: 400,
                                  }
                                }
                              },
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                              transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                              },
                            }}
                            sx={{ 
                              maxWidth: 160,
                              fontSize: "10px",
                              fontWeight: 400,
                              "& .MuiSelect-select": {
                                fontSize: "10px",
                                fontWeight: 400
                              }
                            }}
                          >
                            {this.state.loading && (
                              <MenuItem disabled sx={{ 
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "40px 16px",
                                fontSize: "10px",
                                fontWeight: 400,
                                color: "#6b7280"
                              }}>
                                <div style={{ 
                                  display: "flex", 
                                  flexDirection: "column", 
                                  alignItems: "center", 
                                  gap: "12px" 
                                }}>
                                  <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                  <span>Loading destination types...</span>
                                </div>
                              </MenuItem>
                            )}
                            
                            {!this.state.loading && Array.from(new Set(this.state.DAGs.map(d => d.subtype))).filter(Boolean).map(subtype => (
                              <MenuItem key={subtype} value={subtype} sx={{ 
                                fontSize: "10px", 
                                fontWeight: 400, 
                                wordBreak: "break-all",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <span>{subtype}</span>
                                {this.renderDestinationTypeLogo(subtype)}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    {(this.state.filters.status.length + this.state.filters.subtype.length + (this.state.jobNameFilters ? 1 : 0) + (this.state.jobDestinationFilters ? 1 : 0)) > 0 && (
                      <div style={{ marginBottom: "16px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                          <span style={{ fontSize: "10px", fontWeight: 400 }}>Active filters:</span>
                          
                          {this.state.jobNameFilters && (
                            <span style={{
                              backgroundColor: "#eff6ff",
                              color: "#1d4ed8",
                              padding: "4px 8px",
                              borderRadius: "16px",
                              fontSize: "10px",
                              fontWeight: 400,
                              display: "flex",
                              alignItems: "center",
                              gap: "4px"
                            }}>
                              Push Alias: {this.state.jobNameFilters}
                              <Icon.X 
                                size={14} 
                                style={{ cursor: "pointer" }} 
                                onClick={() => this.setState({ jobNameFilters: "", currentPage: 1 })}
                              />
                            </span>
                          )}

                          {this.state.jobDestinationFilters && (
                            <span style={{
                              backgroundColor: "#eff6ff",
                              color: "#1d4ed8",
                              padding: "4px 8px",
                              borderRadius: "16px",
                              fontSize: "10px",
                              fontWeight: 400,
                              display: "flex",
                              alignItems: "center",
                              gap: "4px"
                            }}>
                              Destination: {this.state.jobDestinationFilters}
                              <Icon.X 
                                size={14} 
                                style={{ cursor: "pointer" }} 
                                onClick={() => this.setState({ jobDestinationFilters: "", currentPage: 1 })}
                              />
                            </span>
                          )}
                          
                          {this.state.filters.status.map(status => (
                            <span key={status} style={{
                              backgroundColor: "#eff6ff",
                              color: "#1d4ed8",
                              padding: "4px 8px",
                              borderRadius: "16px",
                              fontSize: "10px",
                              fontWeight: 400,
                              display: "flex",
                              alignItems: "center",
                              gap: "4px"
                            }}>
                              Status: {status}
                              <Icon.X 
                                size={14} 
                                style={{ cursor: "pointer" }} 
                                onClick={() => this.toggleFilter("status", this.state.filters.status.filter(s => s !== status))}
                              />
                            </span>
                          ))}

                          {this.state.filters.subtype.map(subtype => (
                            <span key={subtype} style={{
                              backgroundColor: "#eff6ff",
                              color: "#1d4ed8",
                              padding: "4px 8px",
                              borderRadius: "16px",
                              fontSize: "10px",
                              fontWeight: 400,
                              display: "flex",
                              alignItems: "center",
                              gap: "4px"
                            }}>
                              Type: {subtype}
                              <Icon.X 
                                size={14} 
                                style={{ cursor: "pointer" }} 
                                onClick={() => this.toggleFilter("subtype", this.state.filters.subtype.filter(t => t !== subtype))}
                              />
                            </span>
                          ))}
                          
                          <Button
                            variant="text"
                            size="small"
                            onClick={() => this.setState({ 
                              filters: { status: [], subtype: [] },
                              jobNameFilters: "",
                              jobDestinationFilters: "",
                              currentPage: 1
                            })}
                            sx={{ fontSize: "10px", fontWeight: 400, color: "#6b7280" }}
                          >
                            Clear all
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>

                  <Table
                    headings={[
                      {
                        width: "6%",
                        columnName: "Logo",
                        isSortable: "false",
                        Children: () => "",
                      },
                      {
                        columnName: "alias",
                        isSortable: true,
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            Push alias
                            {children}
                          </span>
                        ),
                      },
                      {
                        columnName: "push_from",
                        isSortable: true,
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            source in DWH
                            {children}
                          </span>
                        ),
                      },
                      {
                        columnName: "push_to",
                        isSortable: true,
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            destination
                            {children}
                          </span>
                        ),
                      },
                      {
                        columnName: "last_started",
                        isSortable: true,
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            last started
                            {children}
                          </span>
                        ),
                      },
                      {
                        columnName: "last_ended",
                        isSortable: true,
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            last ended
                            {children}
                          </span>
                        ),
                      },
                      {
                        columnName: "status",
                        isSortable: false,
                        Children: ({children}) => 
                          <span className="d-flex align-items-center h-100">
                            status
                            {children}
                          </span>,
                      },
                      {
                        width: "10%",
                        columnName: "actions",
                        isSortable: "false",
                        Children: () => "Actions",
                      },
                    ]}
                    rows={this.paginateArray(
                      this.state.DAGs?.filter((DAGtarget) =>
                        this.filterJobNames(DAGtarget) && 
                        this.filterJobDestination(DAGtarget) &&
                        this.filterByColumn(DAGtarget, "status", this.state.filters.status) &&
                        this.filterByColumn(DAGtarget, "subtype", this.state.filters.subtype)
                      )
                    ).map((dag, index) => ({
                      key: `${dag.id}${index}`,
                      columns: [
                        {
                          type: "image",
                          logo: dag.logo,
                        },
                        {
                          type: "text",
                          text: dag.alias,
                        },
                        {
                          type: "text",
                          text: dag.push_from,
                        },
                        {
                          type: "component",
                          component: (
                            <div className="d-flex align-items-center">
                              <span>{dag.push_to}</span>
                              {dag.subtype === "Google Sheets" && (
                                <a
                                  href={dag.push_to_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    marginLeft: '8px',
                                    color: '#2D49FD',
                                  }}
                                >
                                  <Icon.ExternalLink size={14} />
                                </a>
                              )}
                            </div>
                          ),
                        },
                        {
                          type: "date",
                          date: dag.last_started,
                        },
                        {
                          type: "date",
                          date: dag.last_ended,
                        },
                        {
                          type: "status",
                          key: dag.status,
                        },
                        {
                          type: "component",
                          component: (
                            <HorizontalDropdownMenu
                              items={[
                                {
                                  tooltipTitle: "Trigger Push",
                                  variant: "no-outline-success",
                                  disabled: dag.version !== "v2" || dag.status === "running" || dag.status === "queued",
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    this.triggerDAG(dag.id);
                                  },
                                  children: (dag.status === "running" || dag.status === "queued") ? (
                                    <CircularProgress size={16} sx={{ color: "#2c49fc" }} />
                                  ) : (
                                    <PlayIcon />
                                  ),
                                },
                                {
                                  tooltipTitle: "Push Details",
                                  variant: "no-outline",
                                  disabled: dag.subtype === "Tableau",
                                  className: "me-1 mb-1",
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    navigate(`/jobs/push?edit_push=${dag.id}`);
                                  },
                                  children: (
                                    <SettingsIcon className="bigger-svg" />
                                  ),
                                },
                                {
                                  tooltipTitle: "Open History",
                                  disabled: false,
                                  className: "me-1 mb-1",
                                  variant: "no-outline",
                                  onClick: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.redirectToHistoryModalView(dag, e);
                                  },
                                  children: <OptionsIcon />,
                                },
                                {
                                  tooltipTitle: "Stop Push",
                                  variant: "no-outline-danger",
                                  className: "me-1 mb-1",
                                  disabled: true,
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    this.stopDAG(
                                      dag.id,
                                      this.state.dag_runs[dag.id][0].dag_run_id
                                    );
                                  },
                                  children: <StopIcon />,
                                },
                                {
                                  tooltipTitle: "Delete Push",
                                  variant: "no-outline-danger",
                                  className: "mb-1",
                                  disabled: false,
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    this.toggleDeletepushmodal(
                                      dag.alias,
                                      dag.id
                                    );
                                  },
                                  children: <CancelIcon />,
                                },
                              ]}
                            />
                          ),
                        },
                      ],
                    }))}
                    sortedColumn={this.state.sortedColumn}
                    onSortColumn={this.onSortColumn}
                    isLoading={this.state.loading}
                  />
                  <TablePagination
                    currentPage={this.state.currentPage}
                    totalPages={this.calculateTotalPages()}
                    updatePageNum={(num) => this.setState({ currentPage: num })}
                    updatePerPage={(num) => this.setState({ perPage: num })}
                    activeTable={this.state.jobNameFilters}
                  />
                </>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>

        <DeleteConnectorModal
          isShown={this.state.modal_delete_push}
          onHide={() => this.toggleDeletepushmodal()}
          onAction={() =>
            this.deletePush(
              this.state.deleting_push_alias,
              this.state.delete_push_id
            )
          }
          deleteData={{
            logo: this.state.delete_logo,
            deleting: this.state.deleting_push,
          }}
          text={{
            bold: this.state.deleting_push_alias,
            regular: "push",
          }}
        />

        <CSSTransition
          in={this.state.isShowingDagHistoryTable}
          classNames="form-tab"
          timeout={300}
          unmountOnExit
        >
          <DagHistory
            dagList={Boolean(this.state.DAGs.length) && this.state.DAGs}
            show_logs={true}
            hideTaskTimeline={true}
            onClose={() => {
              this.setState({
                isShowingDagHistoryTable: false,
              });
              navigate("/jobs/push");
            }}
          />
        </CSSTransition>

        <CSSTransition
          in={this.state.isShowingCreatePushForm}
          classNames="form-tab"
          timeout={300}
          unmountOnExit
        >
          <PushCreatorForm
            dagsList={this.state?.DAGs}
            setSelectedPushData={this.setSelectedPushData}
            isEditingPush={new URLSearchParams(window.location.search).get(
              "edit_push"
            )}
            toggleCreatePushForm={this.toggleCreatePushForm}
            fetchAirflowDags={this.fetchAirflowDags}
            editorURL={this.state.sql_editor_url}
          />
        </CSSTransition>
      </div>
    );
  }
}

export default WithRouter(TenantContextComponent);
